<script setup>
import { computed, ref } from 'vue'
const props = defineProps({
  modelValue: {
    type: String,
    default: ''
  },
  options: {
    type: Array,
    default: () => []
  },
  dropdown: {
    type: Boolean,
    default: false
  },
  multiple: {
    type: Boolean,
    default: false
  }
})
const emit = defineEmits(['update:modelValue'])
const suggestions = ref([])
const objects = computed(() => props.options[0] && typeof props.options[0] === 'object')
const localVal = computed({
  get: () => (objects.value ? props.options.find((opt) => opt.value === props.modelValue)?.text : props.modelValue),
  set: (value) => emit('update:modelValue', value.value || value)
})
const search = (event) => {
  suggestions.value = props.options.filter((option) => (option.text || option).toLowerCase().includes(event.query.toLowerCase()))
}
</script>

<template>
  <p-auto-complete
    v-model="localVal"
    :suggestions="suggestions"
    :option-label="objects ? 'text' : undefined"
    :option-value="objects ? 'value' : undefined"
    placeholder="Type to Search..."
    :dropdown="dropdown"
    :multiple="props.multiple"
    @complete="search"
  >
    <template #option="slotProps">
      <slot
        name="option"
        v-bind="slotProps"
      />
    </template>
  </p-auto-complete>
</template>
